import instance from '@apis/instance';
import {
    GetTierHistoryParams, TierBenefitsResponse, TierCalculationCyclesResponse, TierHistoryResponse, TierResponse,
} from '@models/tier';

class TierApi {
    /**
     * 내 등급 조회
     * @description 등급 정책이 ACTIVE가 아니거나 startDate가 오늘 이후인 경우 400을 반환한다.
     */
    static getTier(): Promise<TierResponse> {
        return instance.get('/v0/tier');
        // return Promise.resolve(mockTierResponse);
    }

    /**
     * 전체 등급별 혜택 목록 조회
     * @description ACTIVE 정책의 전체 등급 목록, 달성 조건 설명, 혜택을 조회한다.
     */
    static getTierBenefits(): Promise<TierBenefitsResponse> {
        return instance.get('/v0/tier/benefits');
        // return Promise.resolve(mockTierBenefitsResponse);
    }

    /**
     * 특정 주기 적립 내역 조회
     * @description calculatedDate 없이 호출하면 현재 진행 중인 주기의 적립 내역을 반환한다.
     * calculatedDate를 제공하면 해당 산정 완료 주기의 적립 내역을 반환한다.
     * 해당 calculatedDate에 대한 산정 이력이 없으면 404를 반환한다.
     */
    static getTierHistory(params: GetTierHistoryParams): Promise<TierHistoryResponse> {
        return instance.get('/v0/tier/calculation-cycle/history', { params });
        // return Promise.resolve(mockTierHistoryResponse);
    }

    /**
     * 등급 산정 주기 이력 조회
     *  @description 진행 중인 주기 1개(IN_PROGRESS) + 이전 산정 완료 주기 최대 3개(CALCULATED), 총 4개 주기를 반환한다.
     */
    static getTierCalculationCycles(): Promise<TierCalculationCyclesResponse> {
        return instance.get('/v0/tier/calculation-cycles');
        // return Promise.resolve(mockTierCalculationCyclesResponse);
    }
}

export default TierApi;
